import { useIntl } from 'react-intl';

import { Typography } from '@/components/ui/typography';

interface ContractsTableHeaderProps {
  gridTemplateColumns: string;
}

export function ContractsTableHeader({
  gridTemplateColumns,
}: ContractsTableHeaderProps) {
  const intl = useIntl();

  const tableHeaders = [
    intl.formatMessage({
      defaultMessage: 'Board',
      description: 'Header for the contract name',
    }),
    intl.formatMessage({
      defaultMessage: 'Actions',
      description: 'Header for the actions',
    }),
  ];

  return (
    <div
      className="border-fx-neutral-200 bg-fx-neutral-50 grid gap-x-4 border-y px-4 py-3.5"
      style={{ gridTemplateColumns }}
    >
      {tableHeaders.map(header => (
        <Typography
          variant="subtitle1"
          className="!text-fx-neutral-600"
          key={header}
        >
          {header}
        </Typography>
      ))}
    </div>
  );
}
